module.exports = __webpack_public_path__ + "static/media/W09F2160-WEB5.322e1ff8.svg";